import { format, setDate } from "date-fns";
import { useState } from "react";
import { Button, ButtonGroup, Container } from "reactstrap";
import { useGetReportIgoraQuery } from "../../features/CallApi";
import { useEffect } from "react";
import LoadScreen from "../UI/LoadScreen";
import useToken from "../useToken";
import { TypeOfPay } from "../Orders/OrderTypeOfPay";
import { PaymentsType } from "./PaymentsType";


export const ReportsIgora = () => {
    // const [startDate, setStartDate] = useState(format(new Date(Date.now()), "yyyy-MM-dd"))
    const [startDate, setStartDate] = useState(format(new Date(Date.now()), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(Date.now()), "yyyy-MM-dd"))
    const { token, role } = useToken();


    const { data, refetch, isLoading } = useGetReportIgoraQuery({ startDate, endDate })

    // const getReportExcelIgora = () => {
    //     fetch(`/api/reportsservice/orderitemsexport/?startDate=${startDate}&endDate=${endDate}`, {
    //         headers: {
    //             'Authorization': 'Bearer ' + token,
    //         }
    //     }).then(response => response.blob())
    //         .then(blob => {
    //             const link = document.createElement("a");
    //             link.href = URL.createObjectURL(blob);
    //             link.download = "Report_" + startDate + "_" + endDate + ".xlsx";
    //             link.click();
    //         })
    //         .catch(console.error);
    // }
    const getReportExcelAgentIgora = () => {
        fetch(`/api/reportsservice/orderitemsexportagentform/?startDate=${startDate}&endDate=${endDate}`, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        }).then(response => response.blob())
            .then(blob => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "Agent_Report_" + startDate + "_" + endDate + ".xlsx";
                link.click();
            })
            .catch(console.error);
    }
    const getReportOfClientsExcelIgora = () => {
        fetch(`/api/reportsservice/orderitemsofclientsexport/?startDate=${startDate}&endDate=${endDate}`, {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        }).then(response => response.blob())
            .then(blob => {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "Report_Of_Clients" + startDate + "_" + endDate + ".xlsx";
                link.click();
            })
            .catch(console.error);
    }


    return (
        <Container fluid>
            <div>
                <div>
                    <div className="d-inline-flex mt-3 mb-3 input-group">
                        <div className="me-1">
                            <div className="form-floating">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="startDate"
                                    name="startDate"
                                    onChange={
                                        (e) => {
                                            setStartDate(e.target.value)
                                        }
                                    }
                                    defaultValue={format(new Date(Date.now()), "yyyy-MM-dd")} />
                                <label htmlFor="startDate">С</label>
                            </div>
                        </div>
                        <div>
                            <div className="form-floating">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="endDate"
                                    name="endDate"
                                    onChange={
                                        (e) => {
                                            setEndDate(e.target.value)
                                        }
                                    }
                                    defaultValue={format(new Date(Date.now()), "yyyy-MM-dd")} />
                                <label htmlFor="endDate">По</label>
                            </div>
                        </div>
                        <ButtonGroup className="ms-1">
                            {/* <Button className="text-white" color="success" onClick={() => { getItem() }}>Поиск</Button> */}
                            {/* <Button className="text-white" color="info" onClick={() => getReportExcelIgora()}>Сохранить в Excel</Button> */}
                            <Button className="text-white" color="info" onClick={() => getReportOfClientsExcelIgora()}>Сохранить в Excel</Button>
                            {(role == "Admins" || role == "Buh") &&
                                <Button className="text-white" color="info"
                                    onClick={() => { getReportExcelAgentIgora() }}
                                >Агентский отчет</Button>
                            }
                        </ButtonGroup>

                    </div>
                </div>
            </div>
            <div>
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>
                                Заказ №
                            </th>
                            <th>
                                Карта №
                            </th>
                            <th>
                                Баланс
                            </th>
                            <th>
                                Способ оплаты
                            </th>
                            <th>
                                Реализована в кассе ЛЦ(дата)
                            </th>
                            <th>
                                Срок действия сертификата
                            </th>
                            <th>
                                ФИО гостя
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.length > 0 ? <>
                            {!isLoading ?
                                <>
                                    {data.map(item =>
                                        <tr key={item.id}>
                                            <td>
                                                {item.order.id}
                                            </td>
                                            <td>
                                                {item.productSN}
                                            </td>
                                            <td>
                                                {item.product.price}
                                            </td>
                                            <td>
                                                {item.order.typeOfPay !== null &&
                                                    <TypeOfPay typeOfPay={item.order.typeOfPay} />
                                                }
                                                {item.order.paymentsType &&
                                                    <PaymentsType dataString={item.order.paymentsType} />
                                                }

                                            </td>
                                            <td>
                                                {format(new Date(item.order.orderDate), "dd.MM.yyyy")}

                                            </td>
                                            <td>
                                                {format((new Date(item.order.orderDate).setFullYear(new Date(item.order.orderDate).getFullYear() + 1)), "dd.MM.yyyy")}
                                            </td>
                                            <td>
                                                {item.order.client.lastName + " " + item.order.client.firstName + " " + item.order.client.patronymic}
                                            </td>
                                        </tr>
                                    )
                                    }
                                </> : <LoadScreen />}
                        </> :
                            <tr><td colSpan={5} className="text-center mt-5 mb-5"><strong>Список пуст</strong></td></tr>
                        }
                    </tbody>
                </table>
            </div>
        </Container>
    );
}